import { gtag_report_conversion_phone } from '@/utils/event';
export default {
  name: "fixedRightButton",
  data() {
    return {
      showPhone: false
    };
  },
  methods: {
    phone() {
      window?.gtag_click_all && window.gtag_click_all(1);
      this.showPhone = !this.showPhone;
      if (this.showPhone == true) {
        window?.gtag_report_conversion_phone && window.gtag_report_conversion_phone();
      }
      // gtag_report_conversion_phone()
    },
    chat() {
      window?.gtag_click_all && window.gtag_click_all(1);
    },
    top() {
      const c = document.documentElement.scrollTop;
      if (c > 0) {
        window.requestAnimationFrame(this.top);
        window.scrollTo(0, c - c / 12 - 1);
      }
    },
    handleClickOnButton() {},
    handleClickOutside() {
      this.showPhone = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  onBeforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};